package org.gstechnovos.jexonplastech.sections.about.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val StoryContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.fillMaxWidth().backgroundColor(palette.custom.lightGray)
    }
}

val TimelineItemStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.position(Position.Relative).padding(left = 24.px, bottom = 32.px)
            // The vertical line connecting the timeline
            .borderLeft(2.px, LineStyle.Solid, palette.brand.primarySoft)
    }
}

val TimelineDotStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.position(Position.Absolute)
            // Perfectly centers the 12px dot over the 2px left border
            .left((-6).px).top(4.px).size(12.px).borderRadius(50.percent).backgroundColor(palette.brand.primaryBlue)
            .boxShadow(0.px, 0.px, 0.px, 4.px, color = palette.brand.primarySoft.toRgb().copyf(alpha = 0.5f))
    }
}